import React from 'react';

function TopInfo(props) {
    const { title, onClick, style = {} } = props;
    return (
        <div style={{ overflow: 'hidden', ...style }}>
            <div style={{ float: 'left' }}>
                {
                    !!title && <i
                        className="icon iconfont"
                        style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                    >&#xe65b;</i>
                }
                {title}
            </div>
            <div style={{ float: 'right', marginRight: 10, color: '#1296DB', cursor: 'pointer' }} onClick={() => onClick()}>
                <i
                    className="icon iconfont"
                    style={{ marginRight: 4, fontSize: '20px' }}
                >&#xe63d;</i>
                返回
            </div>
        </div>
    );
}

export default TopInfo;


// WEBPACK FOOTER //
// ./src/components/basicElement/TopInfo.js